import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { useStore } from './store';
import { Navbar } from './components/layout/Navbar';
import { Footer } from './components/layout/Footer';
import { CookieBanner } from './components/layout/CookieBanner';
import { HomePage } from './pages/HomePage';
import { MissionsPage } from './pages/MissionsPage';
import { CreateMissionPage } from './pages/CreateMissionPage';
import { MercenariesPage } from './pages/MercenariesPage';
import { ProfilePage } from './pages/ProfilePage';
import { ChatsPage } from './pages/ChatsPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { TermsPage } from './pages/TermsPage';
import './styles/globals.css';
import './styles/components.css';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { currentUser } = useStore();
  if (!currentUser) return <Navigate to="/" replace />;
  return <>{children}</>;
};

const App: React.FC = () => {
  const { theme } = useStore();

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  return (
    <BrowserRouter>
      <Navbar />
      <main style={{ flex: 1 }}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/missions" element={<MissionsPage />} />
          <Route path="/missions/create" element={
            <ProtectedRoute><CreateMissionPage /></ProtectedRoute>
          } />
          <Route path="/mercenaries" element={<MercenariesPage />} />
          <Route path="/profile" element={
            <ProtectedRoute><ProfilePage /></ProtectedRoute>
          } />
          <Route path="/chats" element={
            <ProtectedRoute><ChatsPage /></ProtectedRoute>
          } />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
      <CookieBanner />
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: 'rgba(8,14,28,0.97)',
            color: 'var(--silver)',
            border: '1px solid var(--glass-border)',
            fontFamily: 'var(--font-mono)',
            fontSize: '.75rem',
            letterSpacing: '.04em',
            backdropFilter: 'blur(12px)',
          },
          success: { iconTheme: { primary: '#66bb6a', secondary: '#0a1e14' } },
          error:   { iconTheme: { primary: '#ef5350', secondary: '#1e0a0a' } },
          duration: 3000,
        }}
      />
    </BrowserRouter>
  );
};

export default App;
